<template>
  <div class="page-wrapper">
    <!-- Phần preveu hình ảnh -->
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="lightboxImgs"
      :index="lightboxIndex"
      @hide="onHideLightbox"
    ></vue-easy-lightbox>
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Bảng phân chia công việc</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Bảng phân chia công việc</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <button class="btn add-btn" @click.prevent="openAddColumnModal">
              <i class="fa fa-plus"></i> Thêm cột mới
            </button>
          </div>
        </div>
      </div>
      <div class="card filter-card mb-4" ref="kanbanBoardRef">
        <div
          class="card-header filter-card-header"
          data-toggle="collapse"
          href="#filter_inputs"
          role="button"
          aria-expanded="true"
          aria-controls="filter_inputs"
        >
          <h5 class="card-title mb-0">Bộ lọc công việc</h5>
          <i class="fa fa-chevron-down collapse-icon"></i>
        </div>
        <div class="card-body collapse" id="filter_inputs">
          <div class="row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Tên công việc</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="filters.tieuDe"
                  @keyup.enter="applyFilters"
                  placeholder="Nhập tiêu đề..."
                />
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Trạng thái</label>
                <select
                  class="form-control"
                  v-model="filters.trangThaiCongViec"
                >
                  <option :value="null">Tất cả trạng thái</option>
                  <option value="TODO">Cần làm</option>
                  <option value="IN_PROGRESS">Đang làm</option>
                  <option value="DONE">Hoàn thành</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Độ ưu tiên</label>
                <select class="form-control" v-model="filters.doUuTien">
                  <option :value="null">Tất cả</option>
                  <option value="URGENT">Khẩn cấp</option>
                  <option value="HIGH">Cao</option>
                  <option value="MEDIUM">Trung bình</option>
                  <option value="LOW">Thấp</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Phòng ban</label>
                <vue-multiselect
                  v-model="selectedPhongBan"
                  :options="phongBanOptions"
                  placeholder="Chọn phòng ban"
                  label="tenPhongBan"
                  track-by="idPhongBan"
                  :allow-empty="true"
                  :multiple="false"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                >
                </vue-multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Người thực hiện</label>
                <vue-multiselect
                  v-model="selectedAssignedUser"
                  :options="users"
                  placeholder="Chọn người thực hiện"
                  label="hoTen"
                  track-by="idNguoiDung"
                  :allow-empty="true"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                >
                </vue-multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Độ khó</label>
                <select class="form-control" v-model="filters.doKho">
                  <option :value="null">Tất cả</option>
                  <option value="EASY">Dễ</option>
                  <option value="MEDIUM">Vừa</option>
                  <option value="HARD">Khó</option>
                </select>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <label>Thẻ Tag</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="filters.tags"
                  @keyup.enter="applyFilters"
                  placeholder="Tìm theo thẻ (vd: bug, feature)"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-outline-secondary mr-2"
                @click="resetFilters"
              >
                <i class="fa fa-refresh"></i> Làm mới
              </button>
              <button class="btn btn-primary" @click="applyFilters">
                <i class="fa fa-filter"></i> Lọc
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Header -->
      <!-- <div
        v-if="loadingColum"
        class="text-center py-5"
        :style="{ height: '100vh' }"
      >
        <div
          class="spinner-border text-primary"
          role="status"
          style="width: 3rem; height: 3rem"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div> -->
      <!-- <div v-else-if="columns.length === 0" class="card dash-widget"> -->
      <div v-if="columns.length === 0" class="card dash-widget">
        <div class="card-body d-flex justify-content-center">
          <div class="dash-widget-info">
            <i class="fa fa-tasks"></i>
            <span> Không tìm thấy cột việc làm </span>
          </div>
        </div>
      </div>
      <!-- Kanban Board -->
      <div v-else class="kanban-board">
        <draggable
          v-model="columns"
          class="kanban-container"
          item-key="id"
          ghost-class="ghost-column"
          :animation="200"
          :disabled="true"
        >
          <template #item="{ element: column }">
            <div class="kanban-column" :data-column-id="column.id">
              <!-- Column Header -->
              <div class="kanban-column-header">
                <h5 class="column-title">{{ column.title }}</h5>
                <div class="column-meta">
                  <div class="dropdown kanban-action">
                    <a href="#" data-toggle="dropdown">
                      <i class="fa fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="handleCloneColumn(column)"
                      >
                        Nhân bản cột
                      </a>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="openAssignUsersModal(column)"
                        >Gán người dùng</a
                      >
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="openEditColumnModal(column)"
                        >Sửa & cấu hình</a
                      >
                      <a
                        v-if="column.trangThaiCauHinhCot"
                        class="dropdown-item"
                        href="#"
                        @click.prevent="handleArchivedAllTask(column)"
                        >Lưu trữ tất cả</a
                      >
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent="confirmColumnDelete(column)"
                        >Xóa</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="column.trangThaiCauHinhCot" class="column-header">
                <span
                  v-tooltip="'Tự đông chuyển sang trạng thái hoàn thành'"
                  class="automation-tag"
                  >Hoàn thành</span
                >
              </div>
              <!-- Column Progress Bar -->
              <div class="column-progress">
                <div class="progress" style="height: 8px">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="{
                      width: calculateProgress(column).percentage + '%',
                    }"
                    :aria-valuenow="calculateProgress(column).percentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div class="progress-text">
                  <p>
                    {{ calculateProgress(column).completed }} /
                    {{ calculateProgress(column).total }} Hoàn thành
                  </p>
                  <div
                    class="column-assignees"
                    v-if="
                      column.assignedUsers && column.assignedUsers.length > 0
                    "
                  >
                    <img
                      v-for="user in column.assignedUsers.slice(0, 3)"
                      :key="user.idNguoiDung"
                      :src="
                        user.avatarUrl || '/assets/img/profiles/avatar-02.jpg'
                      "
                      class="task-avatar"
                      width="24"
                      height="24"
                      :alt="user.hoTen"
                      v-tooltip="user.hoTen"
                    />
                    <span
                      v-if="column.assignedUsers.length > 3"
                      class="task-user-count"
                    >
                      +{{ column.assignedUsers.length - 3 }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Column Tasks -->
              <draggable
                v-model="column.tasks"
                class="kanban-task-list"
                :class="{ 'empty-list': column.tasks.length === 0 }"
                item-key="id"
                group="tasks"
                ghost-class="ghost-card"
                @end="onTaskDrop"
                :animation="200"
                :handle="'.drag-handle'"
              >
                <template #item="{ element: task }">
                  <div
                    class="task-card"
                    :data-task-id="task.id"
                    :class="isOverdue(task)"
                  >
                    <!-- Phần hiển thị ảnh -->
                    <div
                      v-if="
                        task.imageAttachments &&
                        task.imageAttachments.length > 0
                      "
                      class="task-cover-image"
                      @click="showImagePreview(task.attachments, 0)"
                    >
                      <img
                        :src="task.imageAttachments[0].fileUrl"
                        :alt="task.imageAttachments[0].originalFileName"
                      />

                      <span
                        v-if="task.imageAttachments.length > 1"
                        class="image-count-badge"
                      >
                        <i class="fa fa-file"></i>
                        {{ task.attachments.length }}
                      </span>
                    </div>
                    <!-- Task Header -->
                    <div class="task-card-header">
                      <div class="task-info-container">
                        <!-- <input
                          type="checkbox"
                          v-model="task.hoanThanh"
                          class="task-checkbox"
                          :id="'task-check-' + task.id"
                          :disabled="isUpdating"
                          @change="handleTaskCompletionToggle(task)"
                        /> -->
                        <label
                          class="task-title"
                          @click.prevent="openViewTaskModal(task)"
                          ><i
                            v-if="task.guiThongBaoHangNgay"
                            class="icon-custom las la-bell mr-1"
                            v-tooltip="'Được thông báo 7 giờ hàng ngày'"
                          ></i
                          >{{ task.title }}</label
                        >
                      </div>
                      <div class="dropdown kanban-task-action">
                        <a href="#" data-toggle="dropdown">
                          <i class="icon-custom fa fa-angle-down"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="
                              task.trangThaiCongViec === 'TODO' &&
                              task.thoiHan &&
                              task.ngayBatDau
                            "
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              handleUpdateStatus(task, 'IN_PROGRESS')
                            "
                          >
                            <!-- <i class="fa fa-play m-r-5"></i> -->
                            Bắt đầu
                          </a>
                          <!-- <a
                            v-if="task.trangThaiCongViec === 'IN_PROGRESS'"
                            class="dropdown-item"
                            href="#"
                            @click.prevent="handleUpdateStatus(task, 'DONE')"
                          >
                            <i class="fa fa-check m-r-5"></i> 
                            Hoàn thành
                          </a> -->
                          <a
                            v-if="task.trangThaiCongViec === 'DONE'"
                            class="dropdown-item"
                            href="#"
                            @click.prevent="
                              handleUpdateStatus(task, 'ARCHIVED')
                            "
                          >
                            Lưu trữ
                          </a>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="openViewTaskModal(task)"
                            >Xem chi tiết</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="openEditTaskModal(task)"
                            >Sửa</a
                          >
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="handleDeleteTask(task)"
                            >Xóa</a
                          >
                        </div>
                      </div>
                      <div class="drag-handle">
                        <i class="icon-custom la la-braille"></i>
                      </div>
                    </div>
                    <!-- Task Content -->
                    <div class="task-car-content">
                      <label
                        class="task-description"
                        @click.prevent="openViewTaskModal(task)"
                        >{{ task.description }}</label
                      >
                    </div>
                    <div class="task-cart-tag">
                      <div
                        v-if="task.tags && task.tags.length"
                        class="task-tags mt-1"
                      >
                        <span
                          v-for="(tag, idx) in task.tags"
                          :key="idx"
                          class="badge task-priority badge-light mr-1 border"
                        >
                          #{{ tag.trim() }}
                        </span>
                        <!-- <span
                          v-for="(tag, idx) in task.tags.slice(0, 2)"
                          :key="idx"
                          class="badge badge-light mr-1 border"
                        >
                          #{{ tag.trim() }}
                        </span> -->
                        <!-- <span
                          v-if="task.tags.length > 2"
                          class="small text-muted"
                          >+{{ task.tags.length - 2 }}</span
                        > -->
                      </div>
                    </div>
                    <!-- /Task Content -->
                    <!-- Task Body -->
                    <div class="task-card-body">
                      <div
                        class="task-countdown"
                        :class="getCountdownClass(task)"
                        v-if="task.thoiHan && task.ngayBatDau"
                      >
                        <i class="fa fa-hourglass-half"></i>
                        <span>{{ countdowns[task.id] || "Đang tính..." }}</span>
                      </div>
                      <div v-else></div>
                      <div>
                        <span
                          v-if="task.doKho"
                          class="badge task-priority ml-1"
                          v-tooltip="'Độ khó nhiệm vụ'"
                          :class="{
                            'badge-success': task.doKho === 'EASY',
                            'badge-warning': task.doKho === 'MEDIUM',
                            'badge-danger': task.doKho === 'HARD',
                          }"
                        >
                          {{
                            task.doKho === "EASY"
                              ? "Dễ"
                              : task.doKho === "MEDIUM"
                              ? "Vừa"
                              : "Khó"
                          }}
                        </span>
                        <span
                          :class="[
                            'task-priority',
                            'badge',
                            task.priority.class,
                          ]"
                          v-tooltip="'Độ ưu tiên nhiệm vụ'"
                        >
                          {{ task.priority.text }}
                        </span>
                      </div>
                    </div>

                    <!-- Task Footer -->
                    <div class="task-card-footer">
                      <div
                        v-if="task.thoiHan && task.ngayBatDau"
                        class="task-dates"
                      >
                        <span
                          ><i class="fa fa-calendar-check-o"></i>
                          {{ formatDate(task.ngayBatDau) }}</span
                        >
                        <span
                          ><i class="fa fa-calendar-times-o"></i>
                          {{ formatDate(task.thoiHan) }}</span
                        >
                      </div>
                      <div v-else></div>

                      <div class="task-assignees ml-1">
                        <img
                          v-for="user in task.users.slice(0, 1)"
                          :key="user.idNguoiDung"
                          :src="user.avatarUrl"
                          class="task-avatar"
                          width="24"
                          height="24"
                          alt="{{user.hoTen }}"
                          v-tooltip="user.hoTen || 'User'"
                        />
                        <span v-if="task.userCount > 1" class="task-user-count"
                          >+{{ task.userCount - 1 }}</span
                        >
                      </div>
                    </div>
                    <div class="task-card-footer2">
                      <div class="task-footer-right">
                        <div class="task-notifications">
                          <span
                            v-if="task.unreadTaskCount > 0"
                            class="task-notification-badge task-badge"
                            v-tooltip.top="
                              `Có ${task.unreadTaskCount} thông báo công việc mới`
                            "
                          >
                            <i class="fa fa-bell"></i>
                            {{
                              task.unreadTaskCount > 9
                                ? "9+"
                                : task.unreadTaskCount
                            }}
                          </span>

                          <span
                            v-if="task.unreadCommentMentionCount > 0"
                            class="task-notification-badge comment-mention-badge"
                            v-tooltip.top="
                              `Có ${task.unreadCommentMentionCount} bình luận nhắc đến bạn`
                            "
                          >
                            <i class="fa fa-user"></i>
                            {{
                              task.unreadCommentMentionCount > 9
                                ? "9+"
                                : task.unreadCommentMentionCount
                            }}
                          </span>
                          <span
                            v-if="task.unreadCommentCount > 0"
                            class="task-notification-badge comment-badge"
                            v-tooltip.top="
                              `Có ${task.unreadCommentCount} bình luận mới`
                            "
                          >
                            <i class="fa fa-comment"></i>
                            {{
                              task.unreadCommentCount > 9
                                ? "9+"
                                : task.unreadCommentCount
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>

              <!-- Add Task Button -->
              <div class="add-task-wrapper">
                <a
                  href="javascript:void(0);"
                  @click.prevent="openAddTaskModal(column.id)"
                >
                  <i class="fa fa-plus"></i> Thêm nhiệm vụ mới
                </a>
              </div>
            </div>
          </template>
        </draggable>
      </div>
      <!-- /Kanban Board -->

      <!-- Statistics Section -->
      <div class="row mt-4">
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div
            class="card dash-widget kpi-card-total"
            @click="handleFilterStatisticsAndDate('all')"
          >
            <div class="card-body">
              <span class="dash-widget-icon icon-total"
                ><i class="fa fa-tasks"></i
              ></span>
              <div class="dash-widget-info">
                <h3>{{ statistics?.totalTasks ?? 0 }}</h3>
                <span>Tổng Công Việc</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div
            class="card dash-widget kpi-card-progress"
            @click="handleFilterStatisticsAndDate('inProgress')"
          >
            <div class="card-body">
              <span class="dash-widget-icon icon-progress"
                ><i class="fa fa-spinner"></i
              ></span>
              <div class="dash-widget-info">
                <h3>{{ statistics?.inProgressTasks ?? 0 }}</h3>
                <span>Đang Thực Hiện</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
          <div
            class="card dash-widget kpi-card-overdue"
            @click="handleFilterStatisticsAndDate('overdue')"
          >
            <div class="card-body">
              <span class="dash-widget-icon icon-overdue"
                ><i class="fa fa-exclamation-triangle"></i
              ></span>
              <div class="dash-widget-info">
                <h3>{{ statistics?.overdueTasks ?? 0 }}</h3>
                <span>Bị Quá Hạn</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-6 col-sm-6 col-lg-6 col-xl-3"
          @click="handleFilterStatisticsAndDate('completed')"
        >
          <div class="card dash-widget kpi-card-done">
            <div class="card-body">
              <span class="dash-widget-icon icon-done"
                ><i class="fa fa-check-square-o"></i
              ></span>
              <div class="dash-widget-info">
                <h3>{{ statistics?.completedTasks ?? 0 }}</h3>
                <span
                  >{{
                    statistics?.completedTasks - statistics?.archivedTasks ?? 0
                  }}
                  Hoàn Thành + {{ statistics?.archivedTasks ?? 0 }} Lưu trữ
                </span>
                <i
                  class="la la-question-circle"
                  v-tooltip="
                    'Lưu trữ là trạng thái Hoàn thành nhưng được lưu lại'
                  "
                ></i>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-6 col-sm-6 col-lg-6 col-xl-6">
          <div class="card dash-widget kpi-card-archived">
            <div class="card-body">
              <span class="dash-widget-icon icon-archived"
                ><i class="fa fa-archive"></i
              ></span>
              <div class="dash-widget-info">
                <h3>{{ statistics?.archivedTasks ?? 0 }}</h3>
                <span>Lưu trữ</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <!-- /Statistics Section -->

      <!-- Charts Section -->
      <div class="card">
        <div class="card-body">
          <div class="card-header-actions">
            <div class="btn-group btn-group-sm" role="group">
              <button
                v-for="option in periodOptions"
                :key="option.value"
                type="button"
                class="btn"
                :class="{
                  'btn-primary': filters.period === option.value,
                  'btn-light': filters.period !== option.value,
                }"
                @click="handleFilterStatisticsAndDate('period', option.value)"
              >
                {{ option.label }}
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-4 nav-left-chart">
              <ul class="nav nav-tabs nav-tabs-solid d-flex flex-column">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    href="#solid-tab1"
                    data-toggle="tab"
                    >Độ ưu tiên</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#solid-tab5" data-toggle="tab"
                    >Độ khó</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#solid-tab2" data-toggle="tab"
                    >Trạng thái</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#solid-tab3" data-toggle="tab"
                    >Theo cột</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#solid-tab4" data-toggle="tab"
                    >Hoàn thành (7 ngày)</a
                  >
                </li>
              </ul>
            </div>
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-8">
              <div class="tab-content">
                <div class="tab-pane show active" id="solid-tab1">
                  <h3 class="card-title">Tỷ lệ công việc theo độ ưu tiên</h3>
                  <div class="chart-custom" id="priority-donut-chart"></div>
                </div>
                <div class="tab-pane" id="solid-tab5">
                  <h3 class="card-title">Tỷ lệ công việc theo độ khó</h3>
                  <div class="chart-custom" id="difficulty-donut-chart"></div>
                </div>
                <div class="tab-pane" id="solid-tab2">
                  <h3 class="card-title">Tỷ lệ công việc theo trạng thái</h3>
                  <div class="chart-custom" id="status-donut-chart"></div>
                </div>
                <div class="tab-pane" id="solid-tab3">
                  <h3 class="card-title">Phân bổ công việc theo cột</h3>
                  <div class="chart-custom" id="bar-charts"></div>
                </div>
                <div class="tab-pane" id="solid-tab4">
                  <h3 class="card-title">
                    Xu hướng hoàn thành theo ngày (7 ngày gần nhất)
                  </h3>
                  <div class="chart-custom" id="line-charts"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Charts Section -->
    </div>
    <!-- /Page Content -->

    <!-- Modals -->
    <TaskBoardColumModal
      :show="isModalVisible"
      :column-data="selectedColumn"
      @close="closeModal"
      @save="handleSaveColumn"
    />
    <TaskModal
      :show="isTaskModalVisible"
      :task-data="selectedTask"
      :column-id="currentColumnId"
      :mode="taskModalMode"
      @close="closeTaskModal"
      @save="handleSaveTask"
      @switchToEditMode="handleSwitchToEditMode"
    />
    <div
      class="modal custom-modal fade"
      :class="{ show: isAssignModalVisible }"
      style="display: block"
      v-if="isAssignModalVisible"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Gán người dùng cho cột "{{ currentColumnForAssignment?.title }}"
            </h5>
            <button type="button" class="close" @click="closeAssignUsersModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Chọn người dùng</label>
              <vue-multiselect
                v-model="selectedUsersForColumn"
                :options="users"
                :multiple="true"
                placeholder="Tìm và chọn người dùng"
                label="hoTen"
                track-by="idNguoiDung"
                deselect-label="Nhấn Enter để bỏ chọn"
                select-label="Nhấn Enter để chọn"
                selected-label="Đã chọn"
              >
                <template #option="{ option }">
                  <span class="option__title">{{ option.hoTen }}</span>
                </template>
              </vue-multiselect>
            </div>
            <div class="submit-section">
              <button
                class="btn btn-primary submit-btn"
                @click="handleSaveColumnUsers"
              >
                Lưu
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" v-if="isAssignModalVisible"></div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, reactive, watch, nextTick } from "vue";
import draggable from "vuedraggable";
import { useToast } from "vue-toastification";
import TaskBoardColumModal from "../components/TaskColumModal.vue";
import TaskModal from "../components/TaskModal.vue";
import Swal from "sweetalert2";
import VueEasyLightbox from "vue-easy-lightbox";
import { useRoute, useRouter } from "vue-router";
import workColumnService from "@/services/workColumnService";
import taskService from "@/services/taskService";
import taskAssignmentService from "@/services/taskAssignmentService";
import dashboardService from "@/services/taskDashboardService";
import userService from "@/services/userService";
import phongBanService from "@/services/phongBanService";
import { useNotificationStore } from "@/stores/notificationStore";

const toast = useToast();
const route = useRoute();
const router = useRouter?.() || null;
const workspaceId = ref(route.params.id);
const columns = ref([]);
const users = ref([]);
const selectedAssignedUser = ref(null);
const loadingColum = ref(true);

// --- Bắt thông báo fetch data ---
const notificationStore = useNotificationStore();

// --- MODAL MANAGEMENT ---
const isModalVisible = ref(false);
const selectedColumn = ref(null);
const isTaskModalVisible = ref(false);
const selectedTask = ref(null);
const currentColumnId = ref(null);
const taskModalMode = ref("add");
const isUpdating = ref(false);
const isAssignModalVisible = ref(false);
const currentColumnForAssignment = ref(null);
const selectedUsersForColumn = ref([]);
const kanbanBoardRef = ref(null);
const phongBanOptions = ref([]);
const selectedPhongBan = ref(null);

// Dùng reactive để quản lý object bộ lọc
const filters = reactive({
  tieuDe: "",
  trangThaiCongViec: null,
  doUuTien: null,
  assignedUserId: null,
  isOverdue: null,
  period: null,
  phongBanId: null,
  doKho: null,
  tags: "",
});

// 1. Thêm biến để Debounce (Chống spam click/spam thông báo)
let debounceTimer = null;

watch(
  () => notificationStore.notifications,
  (newVal, oldVal) => {
    // Nếu trong 500ms có thêm 10 thông báo nữa thì chỉ reload 1 lần cuối cùng
    if (debounceTimer) clearTimeout(debounceTimer);

    debounceTimer = setTimeout(() => {
      console.log("🚀 Thực thi reload bảng Kanban!");
      fetchColumns();
    }, 500); // Chờ 0.5 giây
  },
  { deep: true }
);

// Theo dõi sự thay đổi của người được chọn để cập nhật filter
watch(selectedAssignedUser, (newUser) => {
  filters.assignedUserId = newUser ? newUser.idNguoiDung : null;
});

watch(selectedPhongBan, (newPhongBan) => {
  const pbId = newPhongBan ? newPhongBan.idPhongBan : null;
  filters.phongBanId = pbId;
  fetchUsers(pbId); // Gọi fetchUsers với ID mới
});

const loadPhongBanOptions = async () => {
  try {
    const response = await phongBanService.getActiveOptions();
    if (response.data.data) {
      phongBanOptions.value = response.data.data;
    }
  } catch (error) {
    console.error("Lỗi khi tải danh sách phòng ban:", error);
  }
};

// MỚI: Hàm tải danh sách người dùng cho bộ lọc
const fetchUsers = async (phongBanId = null) => {
  try {
    // Giả định API trả về danh sách người dùng không phân trang
    const apiParams = {};
    if (phongBanId) {
      apiParams.phongBanId = phongBanId;
    }
    const res = await userService.getAll(apiParams);
    users.value = res.data.map((u) => ({
      idNguoiDung: u.idNguoiDung,
      hoTen: u.hoTen,
      avatarUrl: u.avatarUrl,
    }));

    if (
      selectedAssignedUser.value &&
      !users.value.some(
        (u) => u.idNguoiDung === selectedAssignedUser.value.idNguoiDung
      )
    ) {
      selectedAssignedUser.value = null;
      filters.assignedUserId = null;
    }
  } catch (error) {
    console.error("Lỗi khi tải danh sách người dùng:", error);
    toast.error("Không thể tải danh sách người dùng.");
    users.value = []; // Reset nếu lỗi
    selectedAssignedUser.value = null;
    filters.assignedUserId = null;
  }
};

// Hàm áp dụng bộ lọc
const applyFilters = () => {
  fetchColumns(); // Chỉ cần gọi lại hàm fetchColumns là đủ
};

// Hàm reset bộ lọc
const resetFilters = () => {
  filterNull();
  applyFilters(); // Tải lại dữ liệu sau khi reset
};

// Hàm reset nhưng không gọi lại api
const filterNull = () => {
  filters.tieuDe = "";
  filters.trangThaiCongViec = null;
  filters.doUuTien = null;
  filters.assignedUserId = null;
  selectedAssignedUser.value = null;
  filters.isOverdue = null;
  filters.phongBanId = null;
  selectedPhongBan.value = null;
  filters.doKho = null;
  filters.tags = "";
  // filters.period = "weekly";
};

// QUẢN LÝ CÁC NÚT LỌC
const periodOptions = ref([
  { label: "Tất cả", value: null },
  { label: "Hôm nay", value: "daily" },
  { label: "Tuần này", value: "weekly" },
  { label: "Tháng này", value: "monthly" },
]);

// Hàm sử lý lọc theo Statistics
const handleFilterStatisticsAndDate = async (Statistics, value) => {
  // filterNull();
  filters.isOverdue = null;
  switch (Statistics) {
    case "all":
      filterNull();
      break;
    case "inProgress":
      filters.trangThaiCongViec = "IN_PROGRESS";
      break;
    case "overdue":
      filters.trangThaiCongViec = null;
      filters.isOverdue = "true";
      break;
    case "completed":
      filters.trangThaiCongViec = "DONE";
      break;
    case "period":
      filters.period = value;
      break;

    default:
      break;
  }
  applyFilters();

  if (Statistics != "period") {
    await nextTick(() => {
      if (kanbanBoardRef.value) {
        kanbanBoardRef.value.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
};

// Hàm helper để tạo params cho API
const buildFilterParams = () => {
  const params = {};
  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      params[key] = filters[key];
    }
  }
  return params;
};

// --- COUNTDOWN TIMER ---
const countdowns = ref({});
let countdownInterval = null;

// --- HÀM HELPER ĐƯỢC ĐỊNH NGHĨA NGAY TRONG COMPONENT ---
// Hàm ánh xạ Độ ưu tiên từ API (Enum String) sang object mà UI cần
const mapPriority = (apiPriority) => {
  switch (apiPriority) {
    case "HIGH":
      return { key: "HIGH", text: "Cao", class: "bg-inverse-warning" };
    case "URGENT":
      return { key: "URGENT", text: "Khẩn cấp", class: "bg-inverse-danger" };
    case "MEDIUM":
      return { key: "MEDIUM", text: "TB", class: "bg-inverse-info" };
    case "LOW":
    default:
      return { key: "LOW", text: "Thấp", class: "bg-inverse-success" };
  }
};

// --- API METHODS ---
const fetchColumns = async () => {
  loadingColum.value = true;
  try {
    // Xây dựng các tham số lọc
    const params = buildFilterParams();

    // Truyền params vào lời gọi API
    const response = await workColumnService.getAllByWorkspaceId(
      workspaceId.value,
      params
    );

    const mappedColumns = response.data.map((apiColumn) => {
      return {
        id: apiColumn.id,
        title: apiColumn.tenCot,
        _original: apiColumn,
        assignedUsers: apiColumn.assignedUsers || [],
        trangThaiCauHinhCot: apiColumn.trangThaiCauHinhCot,
        tasks: apiColumn.tasks
          ? apiColumn.tasks.map((apiTask) => {
              // Ánh xạ danh sách user từ apiTask
              const mappedUsers = apiTask.assignedUsers
                ? apiTask.assignedUsers.map((apiUser) => {
                    return {
                      // Cần khớp với cấu trúc UI của bạn
                      idNguoiDung: apiUser.idNguoiDung,
                      hoTen: apiUser.hoTen,
                      avatarUrl:
                        apiUser.avatarUrl ||
                        "/assets/img/profiles/avatar-02.jpg", // Cung cấp ảnh mặc định
                    };
                  })
                : [];
              //  Lọc sẵn các file là ảnh
              const imageAttachments = (apiTask.attachments || []).filter(
                (att) => att.fileType && att.fileType.startsWith("image/")
              );

              return {
                id: apiTask.id,
                title: apiTask.tieuDe,
                description: apiTask.moTa,
                ngayBatDau: apiTask.ngayBatDau,
                thoiHan: apiTask.ngayKetThuc,
                ngayTao: apiTask.ngayTao,
                active: apiTask.active,
                hoanThanh: apiTask.trangThaiCongViec === "DONE",
                trangThaiCongViec: apiTask.trangThaiCongViec,
                guiThongBaoHangNgay: apiTask.guiThongBaoHangNgay,
                priority: mapPriority(apiTask.doUuTien),
                imageAttachments: imageAttachments,
                // SỬA Ở ĐÂY: Dùng danh sách user đã được map chính xác
                users: mappedUsers,

                // TỐI ƯU Ở ĐÂY: Tự động tính userCount
                userCount: mappedUsers.length,
                attachments: apiTask.attachments || [],
                unreadTaskCount: apiTask.unreadTaskCount,
                unreadCommentCount: apiTask.unreadCommentCount,
                unreadCommentMentionCount: apiTask.unreadCommentMentionCount,
                doKho: apiTask.doKho,
                tags:
                  apiTask.tags && typeof apiTask.tags === "string"
                    ? apiTask.tags
                        .split(",")
                        .map((t) => t.trim())
                        .filter((t) => t)
                    : [],
                _original: apiTask,
              };
            })
          : [],
      };
    });

    columns.value = mappedColumns;
    fetchStatistics();
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Không thể tải bảng công việc."
    );
    console.error(error);
  } finally {
    loadingColum.value = false;
  }
};

// --- Hàm hiển thị theo trạng thái, countdown time
const updateTaskCountdowns = () => {
  const now = new Date();
  columns.value.forEach((col) => {
    col.tasks.forEach((task) => {
      if (task.hoanThanh) {
        countdowns.value[task.id] = "Đã hoàn thành";
        return;
      }

      if (!task.thoiHan) {
        countdowns.value[task.id] = ""; // Biểu tượng vô cực
        return;
      }

      const dueDate = new Date(task.thoiHan);
      const diffTime = dueDate - now;

      if (diffTime <= 0) {
        const pastDueDiff = now - dueDate;
        const days = Math.floor(pastDueDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (pastDueDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (pastDueDiff % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((pastDueDiff % (1000 * 60)) / 1000);

        let result = "Quá hạn ";
        if (days > 0) result += `${days} ngày `;
        result += `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0"
        )}:${String(seconds).padStart(2, "0")}`;

        countdowns.value[task.id] = result;
        return;
      }

      const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffTime % (1000 * 60)) / 1000);

      let result = "";
      if (days > 0) result += `${days} ngày `;
      result += `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(seconds).padStart(2, "0")}`;

      countdowns.value[task.id] = result;
    });
  });
};

const getCountdownClass = (task) => {
  if (task.hoanThanh) return "deadline-completed";
  if (!task.thoiHan) return "deadline-safe";
  const diffTime = new Date(task.thoiHan) - new Date();
  if (diffTime <= 0) return "deadline-danger";
  if (diffTime < 24 * 60 * 60 * 1000) return "deadline-warning"; // Less than 1 day
  return "deadline-safe";
};
// --- COMPUTED & HELPER FUNCTIONS ---

const calculateProgress = (column) => {
  const total = column.tasks.length;
  if (total === 0) {
    return { total: 0, completed: 0, percentage: 0 };
  }
  const completed = column.tasks.filter((task) => task.hoanThanh).length;
  const percentage = Math.round((completed / total) * 100);
  return { total, completed, percentage };
};
// -- Hiển thị khung theo trạng thái công việc
const isOverdue = (task) => {
  const now = new Date();
  const dueDate = new Date(task.thoiHan);

  if (task.hoanThanh) return "task-completed";
  if (task.trangThaiCongViec === "IN_PROGRESS") return "task-in-progress";
  if (!task.thoiHan) return "";
  if (dueDate < now && !task.hoanThanh) return "task-overdue";
  return "";
};

// --- MODAL HANDLERS (COLUMN & TASK) ---
// --- HÀM SỬ LÝ COLUM ---

const openAddColumnModal = () => {
  selectedColumn.value = null;
  isModalVisible.value = true;
};
const openEditColumnModal = (column) => {
  selectedColumn.value = { ...column };
  isModalVisible.value = true;
};
const closeModal = () => {
  isModalVisible.value = false;
  selectedColumn.value = null;
};
const handleSaveColumn = async (columnData) => {
  try {
    // Chuẩn bị payload để gửi lên API
    const payload = {
      tenCot: columnData.title,
      viTri: columnData.viTri || 0, // Cần đảm bảo có viTri
      trangThaiCauHinhCot: columnData.trangThaiCauHinhCot || null,
      active: columnData.active !== undefined ? columnData.active : true,
    };

    if (columnData.id) {
      // ----- TRƯỜNG HỢP CẬP NHẬT -----
      await workColumnService.update(workspaceId.value, columnData.id, payload);
      toast.success(`Đã cập nhật cột "${payload.tenCot}"!`);
    } else {
      // ----- TRƯỜNG HỢP TẠO MỚI -----
      await workColumnService.create(workspaceId.value, payload);
      toast.success(`Đã tạo cột mới "${payload.tenCot}"!`);
    }

    // Tải lại toàn bộ dữ liệu từ server để đảm bảo đồng bộ
    await fetchColumns();
    closeModal();
  } catch (error) {
    toast.error(error?.response?.data?.message || "Thao tác với cột thất bại.");
    console.error(error);
  }
};
const handleCloneColumn = async (column) => {
  const result = await Swal.fire({
    title: `Nhân bản cột "${column.title}"?`,
    text: "Hệ thống sẽ tạo một bản sao của cột này cùng với tất cả công việc bên trong (Trừ công việc đã lưu trữ).",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Nhân bản ngay",
    cancelButtonText: "Hủy",
  });

  if (result.isConfirmed) {
    // Hiển thị loading tạm thời
    // const loadingToast = toast.info("Đang nhân bản...", { timeout: false });

    try {
      await workColumnService.clone(workspaceId.value, column.id);

      // toast.dismiss(loadingToast);
      toast.success(`Đã nhân bản cột "${column.title}" thành công!`);

      // Tải lại dữ liệu để hiện cột mới
      await fetchColumns();
    } catch (error) {
      // toast.dismiss(loadingToast);
      toast.error(error?.response?.data?.message || "Nhân bản thất bại.");
      console.error(error);
    }
  }
};
const confirmColumnDelete = async (deletableColumn) => {
  if (!deletableColumn) return;
  const result = await Swal.fire({
    title: `Bạn chắc chắn muốn xóa cột "${deletableColumn.title}"?`,
    html: "Hành động này sẽ <strong>xóa vĩnh viễn</strong> và không thể hoàn tác. <br/>Bạn có muốn tiếp tục?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xóa vĩnh viễn!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      // ----- LOGIC XÓA -----
      await workColumnService.deleteById(workspaceId.value, deletableColumn.id);
      toast.success(`Đã xóa cột "${deletableColumn.title}"!`);

      // Tải lại dữ liệu
      await fetchColumns();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xóa cột thất bại.");
      console.error(error);
    }
  }
};

// Các hàm xử lý cho modal gán người dùng
const openAssignUsersModal = (column) => {
  currentColumnForAssignment.value = column;
  // Lấy danh sách người dùng đã được gán sẵn của cột
  selectedUsersForColumn.value = column.assignedUsers
    ? [...column.assignedUsers]
    : [];
  isAssignModalVisible.value = true;
};

const closeAssignUsersModal = () => {
  isAssignModalVisible.value = false;
  currentColumnForAssignment.value = null;
  selectedUsersForColumn.value = [];
};

const handleSaveColumnUsers = async () => {
  if (!currentColumnForAssignment.value) return;

  const column = currentColumnForAssignment.value;
  const selectedUserIds = selectedUsersForColumn.value.map(
    (u) => u.idNguoiDung
  );

  try {
    // === BƯỚC 1: Gọi API để gán người dùng vào cột ===
    await workColumnService.assignUsersToColumn(
      workspaceId.value,
      column.id,
      selectedUserIds
    );
    toast.success(`Đã cập nhật người dùng cho cột "${column.title}"!`);

    // Đóng modal trước để người dùng thấy kết quả ngay
    closeAssignUsersModal();
    // Tải lại dữ liệu để cập nhật avatar trên header cột
    await fetchColumns();

    // === BƯỚC 2: Hỏi người dùng xác nhận đồng bộ ===
    const existingTaskCount = column.tasks.length;
    if (existingTaskCount > 0) {
      const result = await Swal.fire({
        title: `Bạn có muốn áp dụng những người dùng này cho ${existingTaskCount} công việc đã có trong cột không?`,
        html: "Hành động này sẽ <strong>Thêm người dùng ở cột này</strong> vào công việc. <br/>Bạn có muốn tiếp tục?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "rgba(85, 221, 51, 1)",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Xác nhận!",
        cancelButtonText: "Hủy bỏ",
      });
      if (result.isConfirmed) {
        // === BƯỚC 3: Nếu đồng ý, gọi API đồng bộ ===
        try {
          await workColumnService.syncTasks(workspaceId.value, column.id);
          toast.success(
            `Đã đồng bộ thành công ${existingTaskCount} công việc!`
          );

          // Tải lại toàn bộ bảng lần nữa để cập nhật avatar trên task
          await fetchColumns();
        } catch (syncError) {
          toast.error("Đồng bộ công việc thất bại.");
        }
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Gán người dùng thất bại.");
  }
};

const handleArchivedAllTask = async (column) => {
  const result = await Swal.fire({
    title: `Bạn có muốn lưu trữ tất cả công việc ở cột ${column.title}?`,
    html: "Hành động này sẽ <strong>Lưu trữ tất cả công việc ở cột này</strong>. <br/>Bạn có muốn tiếp tục?",
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "rgba(85, 221, 51, 1)",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xác nhận!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    // === BƯỚC 3: Nếu đồng ý, gọi API đồng bộ ===
    try {
      const countTasks = await workColumnService.archiveAllTask(
        workspaceId.value,
        column.id
      );
      toast.success(`Đã lưu trữ thành công ${countTasks.data} công việc!`);

      // Tải lại toàn bộ bảng lần nữa để cập nhật avatar trên task
      await fetchColumns();
    } catch (syncError) {
      toast.error("Đồng bộ công việc thất bại.");
    }
  }
};

// --- HÀM SỬ LÝ TASK ---
const openAddTaskModal = (columnId) => {
  taskModalMode.value = "add";
  selectedTask.value = null;
  currentColumnId.value = columnId;
  isTaskModalVisible.value = true;
};
const openEditTaskModal = (task) => {
  selectedTask.value = { ...task };
  taskModalMode.value = "edit";
  isTaskModalVisible.value = true;
};
const openViewTaskModal = async (task) => {
  selectedTask.value = { ...task };
  taskModalMode.value = "view"; // Set mode
  isTaskModalVisible.value = true;

  try {
    // 2. Gọi API đánh dấu đã đọc và CHỜ nó xong
    await taskService.markAsRead(
      workspaceId.value,
      task._original.workColumnId,
      task.id
    );

    // 3. Sau khi server xác nhận đã đọc xong, mới tải lại danh sách thông báo
    // Lúc này số lượng thông báo mới chính xác là đã giảm đi
    await notificationStore.fetchNotifications(1);
  } catch (error) {
    console.error("Lỗi khi đánh dấu đã đọc:", error);
    // Tùy chọn: Có thể revert lại số đếm trên UI nếu muốn chặt chẽ,
    // nhưng thường với tính năng "đã đọc" thì không cần thiết lắm.
  } finally {
    // Cập nhật giao diện ngay lập tức (không cần chờ API)
    task.unreadTaskCount = 0;
    task.unreadCommentCount = 0;
    task.unreadCommentMentionCount = 0;
  }
};
const closeTaskModal = () => {
  isTaskModalVisible.value = false;
  selectedTask.value = null;
  currentColumnId.value = null;
};

// --- HÀM LƯU CÔNG VIỆC
const handleSaveTask = async (taskDataFromModal) => {
  isUpdating.value = true;
  try {
    // --- Tách danh sách người dùng cần gán ra ---
    const assignedUsers = taskDataFromModal.assignedUsers || [];
    const assignedUserIds = new Set(assignedUsers.map((u) => u.idNguoiDung));

    // Chuẩn bị payload khớp với TaskDto của backend
    const taskPayload = {
      tieuDe: taskDataFromModal.title,
      moTa: taskDataFromModal.description,
      ngayBatDau: taskDataFromModal.ngayBatDau || null,
      ngayKetThuc: taskDataFromModal.thoiHan || null,
      active: taskDataFromModal.active,
      guiThongBaoHangNgay: taskDataFromModal.guiThongBaoHangNgay,
      doUuTien: taskDataFromModal.priority?.key.toUpperCase() || "LOW", // Chuyển đổi lại sang Enum String
      // trangThaiCongViec: taskDataFromModal.hoanThanh ? "DONE" : "TODO", // Nếu đang thực hiện  đổi trạng thái về TODO
      trangThaiCongViec: "TODO",
      viTri: taskDataFromModal.id ? taskDataFromModal._original.viTri : 0,
      attachments: taskDataFromModal.attachments || [],
      doKho: taskDataFromModal.doKho,
      tags: taskDataFromModal.tags,
      // nguoiTaoId: 1, // Lấy từ user đang đăng nhập
      // assignedUsers có thể cần một API riêng để cập nhật
    };

    if (taskDataFromModal.id) {
      // =======================================
      // ----- TRƯỜNG HỢP: CẬP NHẬT TASK -----
      // =======================================
      const taskId = taskDataFromModal.id;
      const columnId = taskDataFromModal._original.workColumnId;

      // 1. Cập nhật thông tin chính của Task
      await taskService.update(
        workspaceId.value,
        columnId,
        taskId,
        taskPayload
      );

      // 2. Xử lý gán/bỏ gán người dùng
      const originalTask = findTaskById(taskId); // Cần hàm helper để tìm task gốc
      const originalUserIds = new Set(
        originalTask ? originalTask.users.map((u) => u.idNguoiDung) : []
      );

      const usersToAdd = [...assignedUserIds].filter(
        (id) => !originalUserIds.has(id)
      );
      const usersToRemove = [...originalUserIds].filter(
        (id) => !assignedUserIds.has(id)
      );

      const assignmentPromises = [
        ...usersToAdd.map((userId) =>
          taskAssignmentService.assign(taskId, userId)
        ),
        ...usersToRemove.map((userId) =>
          taskAssignmentService.unassign(taskId, userId)
        ),
      ];

      if (assignmentPromises.length > 0) {
        await Promise.all(assignmentPromises);
      }

      toast.success(`Cập nhật nhiệm vụ "${taskPayload.tieuDe}" thành công!`);
    } else {
      // ===================================
      // ----- TRƯỜNG HỢP: TẠO MỚI TASK -----
      // ===================================
      const columnId = taskDataFromModal.columnId;

      // 1. Tạo task trước để lấy về ID
      const response = await taskService.create(
        workspaceId.value,
        columnId,
        taskPayload
      );
      const newTaskId = response.data.id; // Giả định API trả về task mới có ID

      if (!newTaskId) {
        throw new Error("API không trả về ID cho task mới.");
      }

      // 2. Nếu có người dùng được chọn, tiến hành gán họ vào task vừa tạo
      if (assignedUserIds.size > 0) {
        const assignmentPromises = [...assignedUserIds].map((userId) =>
          taskAssignmentService.assign(newTaskId, userId)
        );
        await Promise.all(assignmentPromises);
      }

      toast.success(`Đã thêm nhiệm vụ "${taskPayload.tieuDe}"!`);
    }
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Thao tác với nhiệm vụ thất bại ......."
    );
    console.error("Task Save Error:", error);
  } finally {
    // Luôn tải lại dữ liệu và đóng modal sau khi hoàn tất
    await fetchColumns();
    closeTaskModal();
    isUpdating.value = false;
  }
};

// Bổ sung hàm helper này vào trong <script setup> để tìm task
const findTaskById = (taskId) => {
  for (const column of columns.value) {
    const foundTask = column.tasks.find((task) => task.id === taskId);
    if (foundTask) {
      return foundTask;
    }
  }
  return null;
};

// XÓA TASK
const handleDeleteTask = async (taskToDelete) => {
  const result = await Swal.fire({
    title: `Bạn chắc chắn muốn xóa công việc "${taskToDelete.title}"?`,
    html: "Hành động này sẽ <strong>xóa vĩnh viễn</strong> và không thể hoàn tác. <br/>Bạn có muốn tiếp tục?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xóa vĩnh viễn!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      const column = columns.value.find((c) =>
        c.tasks.some((t) => t.id === taskToDelete.id)
      );
      if (!column) return;

      await taskService.deleteById(
        workspaceId.value,
        column.id,
        taskToDelete.id
      );
      toast.success(`Đã xóa công việc "${taskToDelete.title}"`);

      await fetchColumns(); // Tải lại dữ liệu
    } catch (error) {
      toast.error(error?.response?.data?.message || "Xóa công việc thất bại.");
      console.error(error);
    }
  }
};

// Hàm sử lý kéo thả task
const onTaskDrop = async (event) => {
  // 1. Khóa UI để ngăn các thao tác khác
  if (isUpdating.value) {
    toast.info("Đang xử lý, vui lòng đợi...");
    return;
  }
  isUpdating.value = true;

  // 2. Lưu lại trạng thái giao diện hiện tại để có thể hoàn tác nếu API lỗi
  const originalColumnsState = JSON.parse(JSON.stringify(columns.value));

  // const result = await Swal.fire({
  //   title: `Bạn chắc chắn muốn di chuyển nhiệm vụ?`,
  //   html: "Hành động này sẽ <strong>Thay đổi vị trí</strong>. <br/>Bạn có muốn tiếp tục?",
  //   icon: "info",
  //   showCancelButton: true,
  //   confirmButtonColor: "#d33",
  //   cancelButtonColor: "#3085d6",
  //   confirmButtonText: "Xác nhận!",
  //   cancelButtonText: "Hủy bỏ",
  // });
  // if (result.isConfirmed) {
  try {
    const { from, to, item } = event;
    const sourceColumnId = parseInt(from.parentElement.dataset.columnId);
    const destinationColumnId = parseInt(to.parentElement.dataset.columnId);
    const movedTaskId = parseInt(item.dataset.taskId);

    // 3. Xác định các cột bị ảnh hưởng
    const sourceColumn = columns.value.find((c) => c.id === sourceColumnId);
    const destinationColumn = columns.value.find(
      (c) => c.id === destinationColumnId
    );

    if (!sourceColumn || !destinationColumn) {
      throw new Error("Không thể xác định cột.");
    }

    let updatePromises = [];

    // 4. Hàm helper MỚI: Tạo yêu cầu update cho TẤT CẢ task trong một cột
    //    Không còn câu lệnh 'if' phức tạp bên trong nữa.
    const createUpdatePromisesForColumn = (column) => {
      return column.tasks.map((task, index) => {
        const payload = {
          ...task._original,
          viTri: index + 1, // Vị trí mới bắt đầu từ 1
          workColumnId: column.id,
        };
        // Luôn dùng ID cột GỐC của task để API có thể tìm thấy nó
        const originalColumnId = task._original.workColumnId;
        return taskService.update(
          workspaceId.value,
          originalColumnId,
          task.id,
          payload
        );
      });
    };

    // 5. Tạo danh sách tất cả các yêu cầu cần gửi đi
    updatePromises.push(...createUpdatePromisesForColumn(destinationColumn));
    if (sourceColumnId !== destinationColumnId) {
      updatePromises.push(...createUpdatePromisesForColumn(sourceColumn));
    }

    // 6. Gửi đồng loạt tất cả các yêu cầu lên server
    if (updatePromises.length > 0) {
      await Promise.all(updatePromises);
      toast.success("Đã cập nhật vị trí công việc!");
    }

    // 7. QUAN TRỌNG: Nếu thành công, tự cập nhật trạng thái `_original` trên frontend
    //    để chuẩn bị cho lần kéo thả tiếp theo.
    const updateLocalOriginalData = (column) => {
      column.tasks.forEach((task, index) => {
        task._original.viTri = index + 1; // Đồng bộ vị trí mới (+1)
        task._original.workColumnId = column.id;
      });
    };
    updateLocalOriginalData(destinationColumn);
    if (sourceColumnId !== destinationColumnId) {
      updateLocalOriginalData(sourceColumn);
    }

    // 8. Chỉ hỏi khi kéo sang CỘT KHÁC
    if (sourceColumnId !== destinationColumnId) {
      const syncResult = await Swal.fire({
        title: "Đồng bộ người thực hiện?",
        html: `Bạn vừa chuyển task sang cột <strong>${destinationColumn.title}</strong>. Bạn có muốn cập nhật người thực hiện của task này theo danh sách người dùng của cột mới không?`,
        icon: "question",
        showCancelButton: true, // Nút "Không làm gì"
        showDenyButton: true, // Nút "Thay thế"
        confirmButtonText: "Đồng bộ (Thêm)",
        denyButtonText: "Thay thế",
        cancelButtonText: "Không, giữ nguyên",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#d33",
        cancelButtonColor: "#aaa",
      });

      // 9. Xử lý kết quả
      if (syncResult.isConfirmed) {
        // --- Người dùng chọn: ĐỒNG BỘ (Thêm) ---
        await taskService.dongBoNguoiDung(
          workspaceId.value,
          destinationColumnId,
          movedTaskId
        );
        toast.success("Đã đồng bộ (thêm) người dùng vào task.");
      } else if (syncResult.isDenied) {
        // --- Người dùng chọn: THAY THẾ ---
        await taskService.thayTheNguoiDung(
          workspaceId.value,
          destinationColumnId,
          movedTaskId
        );
        toast.success("Đã thay thế người dùng của task.");
      } else {
        // --- Người dùng chọn: KHÔNG LÀM GÌ ---
        toast.info("Đã giữ nguyên người thực hiện của task.");
      }
    }
  } catch (error) {
    // 8. Nếu có bất kỳ lỗi nào, hoàn tác giao diện về trạng thái cũ
    columns.value = originalColumnsState;
    toast.error(
      error?.response?.data?.message || "Không thể lưu thay đổi vị trí."
    );
    console.error("DragDrop Update Error:", error);
  } finally {
    // 9. Luôn mở khóa UI sau khi hoàn tất
    await fetchColumns();
    isUpdating.value = false;
  }
};
//   else {
//     columns.value = originalColumnsState;
//     await fetchColumns();
//     isUpdating.value = false;
//   }
// };
// Hàm thay đổi tên status
const mapStatus = (status) => {
  switch (status) {
    case "TODO":
      return "Chưa làm";
    case "IN_PROGRESS":
      return "Đang làm";
    case "DONE":
      return "Hoàn thành";
    case "ARCHIVED":
      return "Lưu trữ";
    default:
      return "";
  }
};

// HÀM SỬ LÝ SỰ KIỆN THAY ĐỔI TRẠNG THÁI CÔNG VIỆC
const handleUpdateStatus = async (task, newStatus) => {
  const result = await Swal.fire({
    title: `Bạn chắc chắn muốn đổi trạng thái thành ${mapStatus(newStatus)} ?`,
    html: `Hành động này sẽ <strong>Thay đổi trạng thái thành ${mapStatus(
      newStatus
    )}</strong>. <br/>Bạn có muốn tiếp tục?`,
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xác nhận!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      const column = columns.value.find((c) =>
        c.tasks.some((t) => t.id === task.id)
      );
      if (!column) {
        toast.error("Không tìm thấy cột chứa công việc này.");
        return;
      }

      // Chuẩn bị payload đúng như backend mong đợi
      const payload = { newStatus: newStatus };

      await taskService.updateStatus(
        workspaceId.value,
        column.id,
        task.id,
        payload
      );
      toast.success(`Đã cập nhật trạng thái công việc!`);

      // Tải lại dữ liệu để giao diện luôn chính xác
      await fetchColumns();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Cập nhật trạng thái thất bại.";
      toast.error(errorMessage);
      console.error(error);
    }
  }
};

// HÀM SỬ LÝ SỰ KIỆN THAY ĐỔI TRẠNG THÁI CÔNG VIỆC Ô CHECKBOX
// const handleTaskCompletionToggle = async (task) => {
//   if (isUpdating.value) {
//     // Hoàn tác lại thao tác tick của người dùng vì yêu cầu bị bỏ qua
//     task.hoanThanh = !task.hoanThanh;
//     toast.info("Đang xử lý yêu cầu trước đó, vui lòng đợi...");
//     return;
//   }
//   // Xác định trạng thái mới dựa trên hành động của người dùng
//   const newStatus = task.hoanThanh ? "DONE" : "IN_PROGRESS";
//   // Giả định: nếu bỏ tick "hoàn thành", task sẽ quay về trạng thái "đang làm"

//   try {
//     isUpdating.value = true;
//     const column = columns.value.find((c) =>
//       c.tasks.some((t) => t.id === task.id)
//     );
//     if (!column) {
//       toast.error(
//         error?.response?.data?.message ||
//           "Không tìm thấy cột chứa công việc này."
//       );
//       task.hoanThanh = !task.hoanThanh; // Hoàn tác lại thao tác tick
//       return;
//     }

//     const payload = { newStatus: newStatus };

//     await taskService.updateStatus(
//       workspaceId.value,
//       column.id,
//       task.id,
//       payload
//     );

//     toast.success(`Đã cập nhật công việc: "${task.title}"`);

//     // Tải lại dữ liệu để cập nhật progress bar và các thông tin khác
//     await fetchColumns();
//   } catch (error) {
//     // QUAN TRỌNG: Nếu API thất bại, hoàn tác lại thao tác tick trên giao diện
//     task.hoanThanh = !task.hoanThanh;

//     const errorMessage =
//       error.response?.data?.message || "Cập nhật trạng thái thất bại.";
//     if (task.trangThaiCongViec === "TODO")
//       toast.error('Cần nhấn bắt đầu làm "' + task.title + '" trước.');
//     else if (task.trangThaiCongViec === "DONE")
//       toast.error("Nhiệm vụ này đã được hoàn thành.");
//     else toast.error(errorMessage);
//     console.error(error);
//   } finally {
//     // BƯỚC 3: Luôn "mở khóa" sau khi mọi thứ hoàn tất (thành công hoặc thất bại)
//     isUpdating.value = false;
//   }
// };

// hàm thay đổi trạn thái model từ xem sang sửa
const handleSwitchToEditMode = () => {
  taskModalMode.value = "edit";
};

// --- STATE MANAGEMENT CHO THỐNG KÊ ---
const statistics = ref(null);
const isLoadingStatistics = ref(true);

// HÀM FETCH ĐÃ SỬA LẠI
const fetchStatistics = async () => {
  isLoadingStatistics.value = true;
  const params = buildFilterParams();
  try {
    const response = await dashboardService.getWorkspaceStatistics(
      workspaceId.value,
      params
    );

    // Giả sử API của bạn vẫn trả về cấu trúc ApiResponseDto
    if (response.data) {
      statistics.value = response.data;
      // KHI CÓ DỮ LIỆU THÀNH CÔNG, GỌI RENDERCHARTS NGAY LẬP TỨC
      nextTick(() => {
        renderDonutChart(statistics.value);
        renderDonutChartStatus(statistics.value);
        renderBarChart(statistics.value);
        renderLineChart(statistics.value);
        renderDonutChartDifficulty(statistics.value);
      });
    } else {
      toast.error(response.data.message || "Lỗi khi tải dữ liệu thống kê.");
    }
  } catch (error) {
    console.error("Failed to fetch statistics:", error);
    toast.error(
      error?.response?.data?.message || "Không thể tải dữ liệu thống kê."
    );
  } finally {
    isLoadingStatistics.value = false;
  }
};

// --- CHART RENDERING ---
const renderBarChart = (statsData) => {
  // 1. Dùng statsData được truyền vào, không dùng ref toàn cục
  if (typeof Morris === "undefined" || !statsData) {
    return;
  }
  // A. BIỂU ĐỒ CỘT
  const barChartElement = document.getElementById("bar-charts");
  if (barChartElement && statsData.tasksByColumn) {
    barChartElement.innerHTML = "";
    const barData = Object.entries(statsData.tasksByColumn).map(
      ([status, tasks]) => ({ status, tasks })
    );
    if (barData.length > 0) {
      Morris.Bar({
        element: barChartElement,
        data: barData,
        xkey: "status",
        ykeys: ["tasks"],
        labels: ["Số công việc"],
        barColors: ["#453a94"],
        resize: true,
      });
    }
  }
};

const renderDonutChart = (statsData) => {
  // 1. Dùng statsData được truyền vào, không dùng ref toàn cục
  if (typeof Morris === "undefined" || !statsData) {
    return;
  }
  // B. BIỂU ĐỒ TRÒN
  const donutChartElement = document.getElementById("priority-donut-chart");
  if (donutChartElement && statsData.tasksByPriority) {
    donutChartElement.innerHTML = "";
    const formatPriorityLabel = (label) => {
      const labels = {
        HIGH: "Cao",
        MEDIUM: "Trung bình",
        LOW: "Thấp",
        URGENT: "Khẩn cấp",
      };
      return labels[label] || label;
    };
    const priorityData = Object.entries(statsData.tasksByPriority).map(
      ([label, value]) => ({
        label: formatPriorityLabel(label),
        value,
        key: label,
      })
    );

    if (priorityData.length > 0) {
      const priorityChart = Morris.Donut({
        element: donutChartElement,
        data: priorityData,
        colors: ["#dc3545", "#ffc107", "#007bff", "#28a745"],
        resize: true,
      });
      //GÁN SỰ KIỆN CLICK Ở ĐÂY
      priorityChart.on("click", function (i, row) {
        // 'row' là object dữ liệu của phần được click, chứa 'key' mà ta đã thêm ở Bước 2
        if (row.key) {
          handleChartClickAndScroll("priority", row.key);
        }
      });
    }
  }
};

const renderDonutChartStatus = (statsData) => {
  // 1. Dùng statsData được truyền vào, không dùng ref toàn cục
  if (typeof Morris === "undefined" || !statsData) {
    return;
  }
  const donutChartStatusElement = document.getElementById("status-donut-chart");
  if (donutChartStatusElement && statsData.tasksByStatus) {
    donutChartStatusElement.innerHTML = "";
    const formatStatusLabel = (label) => {
      const labels = {
        TODO: "Chờ làm",
        IN_PROGRESS: "Đang làm",
        DONE: "Hoàn thành",
      };
      return labels[label] || label;
    };
    const statusData = Object.entries(statsData.tasksByStatus).map(
      ([label, value]) => ({
        label: formatStatusLabel(label),
        value,
        key: label,
      })
    );

    if (statusData.length > 0) {
      const statusChart = Morris.Donut({
        element: donutChartStatusElement,
        data: statusData,
        colors: ["#007bff", "#989898", "#28a745"],
        resize: true,
      });
      //GÁN SỰ KIỆN CLICK Ở ĐÂY
      statusChart.on("click", function (i, row) {
        // 'row' là object dữ liệu của phần được click, chứa 'key' mà ta đã thêm ở Bước 2
        if (row.key) {
          handleChartClickAndScroll("status", row.key);
        }
      });
    }
  }
};

const renderLineChart = (statsData) => {
  // 1. Dùng statsData được truyền vào, không dùng ref toàn cục
  if (typeof Morris === "undefined" || !statsData) {
    return;
  }
  // Render Trend Chart
  const lineChartElement = document.getElementById("line-charts");
  if (lineChartElement && statsData.completionTrend) {
    lineChartElement.innerHTML = "";
    const morrisTrendData = statsData.completionTrend.map((item) => ({
      day: item.date,
      done: item.completedCount,
    }));
    if (morrisTrendData.length > 0) {
      Morris.Line({
        element: lineChartElement,
        data: morrisTrendData,
        xkey: "day",
        ykeys: ["done"],
        labels: ["Việc hoàn thành"],
        lineColors: ["#28a745"],
        lineWidth: "3px",
        resize: true,
        xLabelFormat: (x) => `${x.getDate()}/${x.getMonth() + 1}`,
        dateFormat: (x) => `Ngày ${new Date(x).toLocaleDateString("vi-VN")}`,
      });
    }
  }
};

// Hàm vẽ biểu đồ Độ khó
const renderDonutChartDifficulty = (statsData) => {
  if (typeof Morris === "undefined" || !statsData) return;

  const chartElement = document.getElementById("difficulty-donut-chart");
  if (chartElement && statsData.tasksByDifficulty) {
    chartElement.innerHTML = "";

    const formatLabel = (label) => {
      const labels = {
        EASY: "Dễ",
        MEDIUM: "Vừa",
        HARD: "Khó",
        UNSPECIFIED: "Không xác định",
      };
      return labels[label] || label;
    };

    const chartData = Object.entries(statsData.tasksByDifficulty).map(
      ([label, value]) => ({
        label: formatLabel(label),
        value: value,
        key: label, // Key gốc để dùng khi click filter
      })
    );

    if (chartData.length > 0) {
      const chart = Morris.Donut({
        element: chartElement,
        data: chartData,
        colors: ["#28a745", "#ffc107", "#dc3545", "#6c757d"], // Xanh, Vàng, Đỏ, Xám
        resize: true,
      });

      // Sự kiện click để lọc
      chart.on("click", function (i, row) {
        if (row.key) {
          handleChartClickAndScroll("difficulty", row.key);
        }
      });
    }
  }
};

// Hàm sử lý khi nhấn vào lọc bằng chart
const handleChartClickAndScroll = async (filterType, filterData) => {
  // 1. Cập nhật bộ lọc
  switch (filterType) {
    case "priority":
      filterNull();
      filters.doUuTien = filterData;

      break;

    case "status":
      filterNull();
      filters.trangThaiCongViec = filterData;
      break;

    case "difficulty":
      filterNull();
      filters.doKho = filterData === "UNSPECIFIED" ? null : filterData;
      break;

    default:
      break;
  }

  // 2. Áp dụng bộ lọc (gọi lại API để lấy dữ liệu mới)
  applyFilters();

  // 3. Đợi DOM cập nhật xong rồi mới cuộn

  await nextTick(() => {
    if (kanbanBoardRef.value) {
      kanbanBoardRef.value.scrollIntoView({ behavior: "smooth" });
    }
  });
};

// --------- PHẦN SỬ LÝ LIGHTBOX HÌNH ẢNH --------------
// 2. Thêm các ref để quản lý lightbox
const lightboxVisible = ref(false);
const lightboxIndex = ref(0); // Index của ảnh đang được xem
const lightboxImgs = ref([]); // Mảng chứa URL của các ảnh trong gallery

// 3. Thêm hàm để hiển thị lightbox
const showImagePreview = (taskAttachments, clickedImageIndex) => {
  // Lọc ra chỉ những file là ảnh từ danh sách đính kèm của task
  const images = taskAttachments
    .filter((att) => att.fileType.startsWith("image/"))
    .map((att) => att.fileUrl); // Thư viện chỉ cần mảng các URL

  if (images.length > 0) {
    lightboxImgs.value = images;
    lightboxIndex.value = clickedImageIndex;
    lightboxVisible.value = true;
  }
};

// 4. Thêm hàm để ẩn lightbox
const onHideLightbox = () => {
  lightboxVisible.value = false;
};

// --- LIFECYCLE HOOKS ---
onMounted(async () => {
  loadPhongBanOptions();
  await fetchUsers();
  await fetchColumns();
  // Lắng nghe sự kiện chuyển tab
  $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
    // e.target là tab vừa được kích hoạt (ví dụ: <a href="#solid-tab2">)
    const targetTabId = $(e.target).attr("href");

    // Dựa vào ID của tab để gọi hàm render tương ứng
    switch (targetTabId) {
      case "#solid-tab1":
        renderDonutChart(statistics.value);
        break;
      case "#solid-tab2":
        renderDonutChartStatus(statistics.value);
        break;
      case "#solid-tab3":
        renderBarChart(statistics.value);
        break;
      case "#solid-tab4":
        renderLineChart(statistics.value);
        break;

      case "#solid-tab5":
        renderDonutChartDifficulty(statistics.value);
        break;
      // Tab 1 không cần vì nó đã được render lúc đầu
    }
  });

  // BƯỚC B: Kiểm tra xem URL có tham số 'openTask' không
  const taskIdToOpen = route.query.openTask;
  const commentIdToFocus = route.query.commentId; // <-- lấy thêm

  if (taskIdToOpen) {
    // BƯỚC C: Nếu có, tìm task tương ứng trong dữ liệu vừa tải về
    // Dùng parseInt để chuyển đổi string từ URL thành số
    filters.period = null;
    applyFilters();
    const taskToOpen = findTaskById(parseInt(taskIdToOpen, 10));

    // BƯỚC D: Nếu tìm thấy task, gọi hàm mở modal
    if (taskToOpen) {
      openViewTaskModal(taskToOpen, { commentId: commentIdToFocus });
    } else {
      console.warn(`Không tìm thấy task với ID: ${taskIdToOpen}`);
    }
    replaceRouter();
  }
  // setTimeout(renderCharts, 500); // Delay to ensure DOM is ready
  updateTaskCountdowns(); // Initial call
  countdownInterval = setInterval(updateTaskCountdowns, 1000);
});

onUnmounted(() => {
  clearInterval(countdownInterval);
});

watch(
  // 1. SỬA LẠI: Phải theo dõi một MẢNG các nguồn
  [
    () => route.query.openTask,
    () => route.query.focusComment,
    () => route.params.id,
  ],

  // 2. SỬA LẠI: Nhận các giá trị mới từ mảng
  // ([newTaskId, newCommentId]) là các giá trị mới
  async (
    [newTaskId, newCommentId, newWorkspaceId],
    [oldTaskId, oldCommentId, oldWorkspaceId]
  ) => {
    // 3. Logic bên trong giữ nguyên (chỉ sửa tên biến)

    if (newWorkspaceId && newWorkspaceId !== oldWorkspaceId) {
      // Reload lại trang hiện tại (trình duyệt sẽ tải lại theo URL mới gồm cả query openTask)
      window.location.reload();
      return; // Dừng ngay lập tức, không chạy các dòng code bên dưới
    }
    // Chỉ kích hoạt khi `newTaskId` (từ URL) có giá trị VÀ modal đang đóng
    if (newTaskId && !isTaskModalVisible.value) {
      // 4. Tìm task trong danh sách *hiện có*
      const taskToOpen = findTaskById(parseInt(newTaskId, 10));

      if (taskToOpen) {
        // 5. Mở modal nếu tìm thấy
        openViewTaskModal(taskToOpen, { commentId: newCommentId });
      } else {
        // 6. SỬA LỖI: Biến 'taskIdToOpen' không tồn tại, phải dùng 'newTaskId'
        console.warn(`Không tìm thấy task với ID: ${newTaskId}`);
      }
    }

    replaceRouter();
  }
  // Bỏ `{ immediate: true }` (để onMounted xử lý lần tải đầu tiên)
);
// Hàm để format ngày tháng
const formatDate = (isoString) => {
  if (!isoString) return ""; // Trả về rỗng nếu ngày không tồn tại
  const date = new Date(isoString);
  // 'vi-VN' sẽ format theo chuẩn dd/mm/yyyy
  return date.toLocaleDateString("vi-VN");
};
const replaceRouter = async () => {
  await nextTick(() => {
    setTimeout(() => {
      router.replace({ query: { ...route.query, openTask: undefined } });
    }, 150);
  });
};
</script>

<style scoped>
/* --- Custom chart ---*/
.chart-custom {
  min-height: 390px;
}
/* --- Main Board Layout --- */
.page-wrapper {
  background-color: #f4f7fc;
}
.kanban-container {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  padding: 10px;
  align-items: flex-start; /* Important for different height columns */
}
/* --- Filter Card --- */
.filter-card-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-card-header .collapse-icon {
  transition: transform 0.3s ease;
}
.filter-card-header[aria-expanded="false"] .collapse-icon {
  transform: rotate(-90deg);
}
/* KPI Card Styles */
.dash-widget {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.dash-widget:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.dash-widget-icon {
  border-radius: 8px;
  color: #fff;
}
/* KPI Colors */
.kpi-card-total {
  background-color: #e7f3ff;
}
.icon-total {
  background-color: #007bff;
}

.kpi-card-progress {
  background-color: #fff8e1;
}
.icon-progress {
  background-color: #ffc107;
}

.kpi-card-overdue {
  background-color: #ffe8e8;
}
.icon-overdue {
  background-color: #dc3545;
}

.kpi-card-done {
  background-color: #e9f9ee;
}
.kpi-card-archived {
  background-color: #f1f1f1;
}
.icon-done {
  background-color: #28a745;
}
.icon-archived {
  background-color: #888888;
}
/* --- Column Styling --- */
.kanban-column {
  flex: 0 0 calc((100% / 4) - 10px);
  width: calc(100% / 4);
  background-color: #eff2f5;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-height: 100vh;
}
/* Tablet (iPad) */
@media (max-width: 1600px) {
  .kanban-column {
    flex: 0 0 calc((100% / 3) - 10px);
    width: calc(100% / 3);
  }
}
@media (max-width: 1024px) {
  .kanban-column {
    flex: 0 0 calc(50% - 10px);
    width: 50%;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .kanban-column {
    flex: 0 0 100%;
    width: 100%;
  }
}
.kanban-column-header {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
}
.column-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.column-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}
.task-count {
  font-size: 0.8rem;
  font-weight: 700;
}

.column-progress {
  padding: 5px 15px 15px;
  flex-shrink: 0;
}
.progress-text {
  font-size: 12px;
  color: #6c757d;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.progress-bar {
  background-color: #007bff;
  transition: width 0.6s ease;
}

/* --- Task List Styling --- */
.kanban-task-list {
  padding: 0 10px 10px;
  flex-grow: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #c5c5c5ff #eff2f5; /* Màu thumb và màu track */
}

.empty-list {
  border: 2px dashed #ced4da;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.02);
  margin-bottom: 10px;
  min-height: 150px;
}

/* --- New Task Card Design --- */
.task-card {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border-left: 4px solid transparent;
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out,
    background-color 0.3s;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 200px;
  justify-content: space-around;
}
.task-card:hover {
  background-color: #e9f4ff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #62acfc;
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out,
    background-color 0.2s ease-in-out, border-color 0.3s;
}

.task-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
.task-info-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}
.task-title {
  font-weight: 700;
  color: #242424;
  line-height: 1.3;
  margin: 0;
  cursor: pointer;
}
.task-description {
  font-weight: 400;
  color: #414141;
  line-height: 1.3;
  margin: 0;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* --- Custom Circular Checkbox --- */
.task-checkbox {
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: #adb5bd;
  width: 20px;
  height: 20px;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s, border-color 0.2s;
}
.task-checkbox:hover {
  border-color: #007bff;
}
.task-checkbox::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  background-color: #28a745;
}
.task-checkbox:checked {
  border-color: #28a745;
}
.task-checkbox:checked::before {
  transform: scale(1);
}

.task-card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.task-countdown {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
}
.task-countdown i {
  margin-right: 6px;
}

.task-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
  gap: 10px;
}

.task-card-footer2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.task-dates {
  font-size: 12px;
  color: #6c757d;
}
.task-dates span {
  margin-right: 10px;
}
.task-dates i {
  margin-right: 4px;
}
.task-priority {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 8px;
  cursor: pointer;
}

.task-assignees {
  display: flex;
  align-items: center;
}
.task-avatar {
  border-radius: 50%;
  margin-left: -8px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.task-user-count {
  height: 24px;
  width: 24px;
  line-height: 20px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #495057;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  margin-left: -8px;
  border: 2px solid #fff;
}

/* --- Task & Countdown Status Styling --- */
.task-completed {
  background-color: #d1fddb;
  border-left-color: #28a745;
}
.task-completed .task-title {
  color: #5a6e5f;
}

.task-in-progress {
  border-left-color: #007bff; /* Màu xanh dương (Bootstrap primary) */
  background-color: #dae8f8; /* Một màu nền xanh nhạt cho nổi bật */
}

/* .task-in-progress .task-title {
  color: #5a7bff;
} */

.icon-custom {
  font-size: 21px;
}
.la-bell {
  color: red;
}
.task-completed .la-braille {
  color: #2c3e50;
}
.drag-handle {
  cursor: grab;
}
.task-overdue {
  background-color: #fff6f6;
  border-left-color: #dc3545;
}

.deadline-safe {
  background-color: #e0f2f1;
  color: #00796b;
}
.deadline-warning {
  background-color: #fff3e0;
  color: #f57c00;
}
.deadline-danger {
  background-color: #ffebee;
  color: #d32f2f;
}
.deadline-completed {
  background-color: #e8f5e9;
  color: #2e7d32;
}

/* --- Ghost/Drag Effect Styling --- */
.ghost-column {
  background-color: rgba(0, 123, 255, 0.1);
  border: 2px dashed #007bff;
  border-radius: 8px;
}
.ghost-card {
  opacity: 0.5;
  background: #c8ebfb;
  border: 1px dashed #333;
}

/* --- Add Task Button --- */
.add-task-wrapper {
  padding: 15px;
  flex-shrink: 0;
}
.add-task-wrapper a {
  display: block;
  text-align: center;
  padding: 10px;
  border-radius: 6px;
  color: #495057;
  background-color: #dee2e6;
  transition: background-color 0.2s ease, color 0.2s ease;
  font-weight: 500;
}
.add-task-wrapper a:hover {
  background-color: #ced4da;
  color: #212529;
  text-decoration: none;
}
.add-task-wrapper a i {
  margin-right: 5px;
}

/* Styling cho khu vực đính kèm */
.task-cover-image {
  width: calc(100% + 30px); /* Kéo dài ra bằng padding của card */
  margin: -15px -15px 0 -15px; /* Vị trí ngay dưới header */
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.task-cover-image img {
  width: 100%;
  height: 120px; /* Chiều cao cố định cho ảnh bìa */
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.task-cover-image:hover img {
  transform: scale(1.05); /* Hiệu ứng phóng to khi di chuột */
}

.image-count-badge {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 10px;
  display: flex;
  align-items: center;
}

.image-count-badge i {
  margin-right: 4px;
}

/* Điều chỉnh lại vị trí của task body khi có ảnh bìa */
.task-card-body {
  margin-top: 10px;
}
.card-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem; /* Tạo khoảng cách với tabs */
  padding-bottom: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.card-header-actions .btn-light {
  border-color: #ddd;
}
@media (min-width: 1200px) {
  .nav-left-chart {
    border-right: 1px solid #ececec;
  }
}

/* Thẻ hoàn thành tự động ở cột */
.column-header {
  display: flex;
  align-items: center;
  justify-content: end;
  padding-left: 15px;
  padding-right: 15px;
  gap: 10px;
}
.automation-tag {
  background-color: #f6ffe6; /* Màu xanh nhạt (hoặc màu nhận diện automation) */
  color: #00cc0a; /* Màu xanh đậm */
  font-size: 0.8rem;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 12px;
  cursor: pointer;
}
/* Wrapper mới cho phần bên phải của footer */
.task-footer-right {
  display: flex;
  align-items: center;
  gap: 10px; /* Khoảng cách giữa thông báo và avatar */
  flex-shrink: 0; /* Ngăn co lại khi tiêu đề dài */
}

/* Container cho các icon thông báo */
.task-notifications {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Style chung cho các badge */
.task-notification-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  color: white;
  padding: 3px 6px;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  animation: pulse-animation 2.5s infinite; /* Áp dụng hiệu ứng nhấp nháy */
}

.task-notification-badge i {
  font-size: 10px;
}

/* Màu riêng cho thông báo Task */
.task-badge {
  background-color: #ffc107; /* Màu vàng (warning) */
  color: #333;
}

.comment-mention-badge {
  background-color: #07cdff;
  color: #333;
}

/* Màu riêng cho thông báo Comment */
.comment-badge {
  background-color: #d33; /* Màu đỏ (danger) */
  color: white;
}

/* Định nghĩa hiệu ứng nhấp nháy (pulse) */
@keyframes pulse-animation {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.4);
  }
  70% {
    transform: scale(1.05); /* Hơi phồng lên */
    box-shadow: 0 0 0 8px rgba(211, 47, 47, 0); /* Tỏa sáng */
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0);
  }
}

/* Áp dụng animation cho cả 2 loại badge, nhưng với màu tỏa sáng khác nhau */
.task-badge {
  animation-name: pulse-task; /* Animation riêng */
}
.comment-badge {
  animation-name: pulse-comment; /* Animation riêng */
}
.comment-mention-badge {
  animation-name: pulse-comment-mention;
}

@keyframes pulse-task {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(255, 193, 7, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}

@keyframes pulse-comment-mention {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(7, 247, 255, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(255, 193, 7, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}

@keyframes pulse-comment {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 8px rgba(211, 47, 47, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(211, 47, 47, 0);
  }
}
</style>
